module.exports = __webpack_public_path__ + "img/hr-tree-01-g-leaves.fce11a30.png";